/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export interface ApiResponse<T> {
  code: number;
  status: string;
  message: string;
  data: T;
  linea: number; //
  tiene_prospecto?: boolean;
  data_antiguos_contratos?: any[];
  total?: number;
}

export interface IErrorResponse {
  code: number;
  status: string;
  message: string;
  data: {
    errors: {
      [key: string]: string[];
    };
  };
}

export enum HTTPResStatusCodeEnum {
  ///* Ok
  OK = 200,
  CREATED = 200,
  FORBIDDEN = 403,
  UNAUTHORIZED = 401,
  ACTIVE_SESSION = 402, // active session
  USER_BLOCKED = 405, // fail login more than 3 times
}
